import { Modal, Text } from '@profitowi/component-library';
import { AxiosError, AxiosResponse } from 'axios';
import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';

import { ModalActions } from 'components';
import ErrorMessages from 'components/ErrorMessages/ErrorMessages';
import { sendReminderDocuments } from 'services/documents';

type Props = {
  refetch: () => void;
};

const SendReminderDocumentsModal = ({ refetch }: Props) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [customError, setCustomError] = useState<string>();
  const documentIds: number[] = state?.documentIds;

  const { error, isError, isLoading, mutate } = useMutation<AxiosResponse, AxiosError>(
    () => sendReminderDocuments(documentIds),
    {
      onSuccess: () => {
        refetch();
        navigate('..');
      },
    }
  );

  useEffect(() => {
    if (!documentIds?.length) {
      setCustomError('Nie wybrano żadnego dokumentu.');
    }
  }, [documentIds]);

  return (
    <Modal title="Potwierdź wysłanie przypomnienia" visible className="text-center !space-y-8">
      <div className="flex flex-col">
        <Text size="lg" className="text-center">
          Czy na pewno chcesz wysłać przypomnienie?
        </Text>
      </div>

      <ModalActions
        disableSubmit={!!customError}
        confirmLabel="Zatwierdź"
        isLoading={isLoading}
        onCancel={() => navigate('..')}
        onConfirm={() => mutate()}
      />
      {(isError || customError) && <ErrorMessages error={error || customError} />}
    </Modal>
  );
};

export default SendReminderDocumentsModal;
